import { useCallback, useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import { fetchWithAuth } from '../utils/fetchWithAuth';
import LoadingSpinner from './LoadingSpinner';
import './PermissionGuard.css';

function MembershipGate() {
  const location = useLocation();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAccess = useCallback(async () => {
    try {
      const response = await fetchWithAuth(`${API_BASE_URL}/me/membership-access`);
      if (response.ok) {
        setStatus(await response.json());
      } else {
        setStatus({ awaitingApproval: false });
      }
    } catch (err) {
      console.error('Membership access check failed:', err);
      setStatus({ awaitingApproval: false });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkAccess();
  }, [checkAccess]);

  if (loading) {
    return (
      <div className="permissions-loading-banner">
        <LoadingSpinner size="md" variant="primary" />
      </div>
    );
  }

  if (status?.awaitingApproval && location.pathname !== '/awaiting-approval') {
    return <Navigate to="/awaiting-approval" replace />;
  }

  return <Outlet />;
}

export default MembershipGate;
